module.exports = __webpack_public_path__ + "static/img/badge-multi-scheduled-mandatory.35c25ea.svg";